export default "__VITE_ASSET__0fabd9c7__"